import { Link } from "react-router-dom";

const COLS = [
  { title: "Discover", links: [["Explore all", "/explore"], ["Guide me", "/guide-me"], ["Nature escapes", "/escapes/nature-escapes"], ["Affordable resets", "/escapes/affordable-resets"]] },
  { title: "Curated for", links: [["Weekend getaways", "/escapes/weekend-getaways"], ["Women-only retreats", "/escapes/women-only-retreats"], ["Outbound escapes", "/escapes/outbound-escapes"]] },
  { title: "Partners", links: [["Apply to host", "/partner"], ["My trips", "/trips"]] },
];

export default function SiteFooter() {
  return (
    <footer className="grain mt-24 bg-primary text-primary-foreground" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-[1.4fr_1fr_1fr_1fr] md:px-8">
        <div>
          <div className="font-display text-3xl">GOSHA</div>
          <p className="mt-4 max-w-xs text-sm text-primary-foreground/70">
            A curated marketplace for all-inclusive getaways in Pakistan and selected outbound corridors. GOSHA is merchant of record: your payment is held until the experience is delivered.
          </p>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <div className="eyebrow text-primary-foreground/50">{c.title}</div>
            <ul className="mt-4 space-y-2 text-sm">
              {c.links.map(([l, to]) => (
                <li key={to}><Link to={to} className="text-primary-foreground/80 hover:text-secondary">{l}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10 px-5 py-5 text-center text-xs text-primary-foreground/50">© 2026 GOSHA. Prices in PKR. Payments are simulated in this preview.</div>
    </footer>
  );
}
